import { render } from "./FaceRecognitionDirectiveModal.vue?vue&type=template&id=5c638096"
import script from "./FaceRecognitionDirectiveModal.vue?vue&type=script&lang=js"
export * from "./FaceRecognitionDirectiveModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__